import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {BehaviorSubject} from "rxjs";
import {MvsObjectNavigationService} from "../../navigation/mvs-object-navigation.service";
import {MvsObjectNavigationEntry} from "../../navigation/mvs-object-navigation-entry";
import {PageComponent} from "../../mvs-page/page.component";
import {MvsCoreService} from "../../service/mvs-core.service";

/**
 * Considered URL Parameter:
 * tid = <ObjectType>:<ObjectId>  or <ObjectType> (without ObjectId)
 * tid-action : <Action> can be empty = any
 */
@Component({
    selector: 'mvs-page',
    template: 'PageComponent',
    standalone: false
})
export class OverviewPageComponent extends PageComponent implements OnInit, OnDestroy, OnChanges {

    navigationObject: BehaviorSubject<MvsObjectNavigationEntry>;

    constructor(
        protected override route: ActivatedRoute,
        protected navigationService: MvsObjectNavigationService,
        protected router: Router,
        protected override coreService: MvsCoreService
    ) {
        super(route, coreService);

    }

    /**
     * Initialization.
     */
    override ngOnInit(): void {
        super.ngOnInit();

    }

    /**
     * Pre Init.
     * @protected
     */
    protected override preInit() {
        super.preInit();

    }


    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);

    }


    /**
     * Clean up.
     */
    override ngOnDestroy(): void {

        super.ngOnDestroy();

    }


}
